import type { IPaymentMethod } from '@/interfaces'

export class PaymentMethod implements IPaymentMethod {
	code: string
	name: string
	constructor({ code, name }: IPaymentMethod) {
		this.code = code
		this.name = name
	}
}
